import {Component, ChangeDetectionStrategy} from "@angular/core"
import {Group} from "@cm/template-nodes"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-group-inspector",
    templateUrl: "./group-inspector.component.html",
    styleUrl: "./group-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class GroupInspectorComponent extends BaseInspectorComponent<Group> {}
